import gsap from 'gsap';
import media from './media';

export default {
  tweenWords(el) {
    const words = Array.from(el.querySelectorAll('span'));
    if (words.length) {
      gsap.fromTo(
        words,
        {
          yPercent: 100,
          z: 0,
        },
        {
          yPercent: -20,
          z: 0,
          duration: 0.7,
          ease: 'power3.out',
          stagger: 0.025,
          delay: 0.1,
          onStart: () => {
            el.classList.add('text-words--active');
          }
        }
      );
    }
  },

  tweenIn(el) {
    const clipPath = { value: 100 };

    gsap.to(
      clipPath,
      {
        value: 0,
        duration: 0.8,
        delay: 0.2,
        ease: 'power2.inOut',
        onUpdate: () => {
          el.style.webkitClipPath = `inset(0% 0% ${clipPath.value}% 0%)`;
          el.style.clipPath = `inset(0% 0% ${clipPath.value}% 0%)`;
        },
        onComplete: () => {
          el.style.webkitClipPath = null;
          el.style.clipPath = null;
        }
      }
    );

    gsap.fromTo(
      el,
      {
        opacity: 0,
        y: '1rem'
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.2,
        ease: 'power4.inOut',
        clearProps: 'all',
        onStart: () => {
          el.classList.remove('is-hidden');
        }
      }
    );
  },

  tweenFloat(el) {
    const duration = 2 + Math.random();
    const delay = 0.8 * Math.random();
    let y = 0;
    while (y > -0.2 && y < 0.2) {
      if (media.test('until-large')) {
        y = -2.1 + (Math.random() * 4.2);
      } else {
        y = -0.7 + (Math.random() * 1.4);
      }
    }

    gsap.fromTo(
      el,
      {
        y: 0,
        z: 0
      },
      {
        y: `${y}rem`,
        z: 0,
        duration,
        ease: 'power1.inOut',
        repeat: -1,
        yoyo: true,
        delay
      }
    );
  },

  tweenRotatedImage(el) {
    const rotation = parseFloat(el.getAttribute('data-rotation') || 0);
    gsap.fromTo(
      el,
      {
        opacity: 0,
        rotation: 0,
        y: '5rem'
      },
      {
        opacity: 1,
        rotation,
        y: 0,
        duration: 0.8,
        delay: 0.3 * Math.random(),
        ease: 'power4.out',
        clearProps: 'all',
        onStart: () => {
          el.classList.remove('is-hidden');
        }
      }
    );
  }
};
